import axiosClient from './axios-client';
import env from '../utils/env';

const loginApi = {
  login: async (formData) => {
    const url = '/wp-admin/admin-ajax.php';
    const response = await axiosClient.post(url, formData);
    return response;
  },

  searchUser: async (data) => {
    const url = '/wp-admin/admin-ajax.php';
    const response = await axiosClient.post(url, data);
    return response;
  },

  getAffiliateByUserID: async (userID) => {
    const config = env();
    const response = await axiosClient.get(`/wp-json/affwp/v1/affiliates/?user_id=${userID}`, {
      headers: {
        Authorization: 'Basic ' + window.btoa(`${config.affiliatePublicKey}:${config.affiliateToken}`)
      }
    });
    return response;
  }
}

export default loginApi;
